<template>
    <div class="lightgray-content p-2 small-font mb-2 pb-2 border-bottom d-flex" :key="index">
        <div class="d-flex w-100 justify-content-between align-items-center container-fluid position-relative">
            <div>
                <strong class="mb-2 red text-uppercase">
                    {{ $t("gracias.producto") }}                     
                    {{ index + 1 }}
                </strong>
                <div>
                    <span class="h3 mb-3 text-italicy">
                        {{ producto.nombre_producto }}
                    </span>
                </div>
                <div style="line-height: 1;">
                    <label>
                        Descripcion:
                    </label>
                    <span>
                        <strong>
                            {{ producto.descripcion }}
                        </strong>
                    </span>
                </div>
                <div>
                    <label class="mb-1 text-bold">
                        {{ $t("gracias.unidades") }}:
                    </label>
                    {{ producto.unidades }}
                </div>
                <div v-if="producto.qr_code">
                    <label class="mb-1 text-bold">
                        {{ $t("gracias.localizador")}}:
                    </label>
                    {{ producto.qr_code }}
                </div>
            </div>

            <div class="text-center ml-3">
                <b-row>
                    <b-col cols="12">
                        <label>{{ $t("gracias.precio") }}</label><br />
                        <span class="h2">
                            <span class="ml-2 h1 m-0">
                                {{ calcularPrecioTotal | formatear_precio }}
                            </span>
                        </span>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            producto: {
                required: true,
                type: Object
            },
            index: {
                required: true,
                type: Number
            }
        },
        computed: {
            calcularPrecioTotal() {
                const priceManagement = Number(this.producto.price_management_interno) === 0 ? Number(this.producto.price_management) : 0;
                return  (this.producto.unidades * Number(this.producto.price)) + (priceManagement * this.producto.unidades);
            },
        }
    }
</script>

<style scoped>
.fixed-bottom {
    left: auto !important;
}
</style>